import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 14",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M9.54.87a1.8 1.8 0 00-3.08 0L.24 11.37A1.75 1.75 0 001.78 14h12.44a1.75 1.75 0 001.54-2.63L9.54.87zM7 4a1 1 0 112 0v4a1 1 0 11-2 0V4zm1 8a1 1 0 100-2 1 1 0 000 2z"
	})
});
export default SvgWarningTriangle;
